<template>
  <!-- 关于畅月 -->
  <div>
    <div v-if="this.$route.path == '/mobile/about'">
      <!-- 顶部导航 -->
      <TopNav></TopNav>
      <!-- 关于畅月轮播图 -->
      <AboutBanner></AboutBanner>
      <!-- 公司简介 -->
      <AboutIntroduce></AboutIntroduce>
      <!-- 畅月里程碑 -->
      <Milepost></Milepost>
      <!-- 权威认证 -->
      <Authority></Authority>
      <!-- 企业文化 -->
      <Culture></Culture>
      <!-- 底部导航 -->
      <ButtonNav></ButtonNav>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../components/mobile/components/TopNav.vue";
import ButtonNav from "../../../components/mobile/components/BottomNav.vue";
import AboutBanner from "../../../components/mobile/About/AboutBanner.vue";
import Milepost from "../../../components/mobile/About/Milepost.vue";
import Authority from "../../../components/mobile/About/Authority.vue";
import Culture from "../../../components/mobile/About/Culture.vue";
import AboutIntroduce from '../../../components/mobile/About/AboutIntroduce.vue'

export default {
  setup() {
    return reactive({});
  },
  components: {
    TopNav,
    ButtonNav,
    AboutBanner,
    Milepost,
    Authority,
    Culture,
    AboutIntroduce,
  },
};
</script>
